import { AbstractDownloadableService } from "./abstract-downloadable.service";
import { Property } from "../models";

/**
 * @class InvoicingPmsApiService
 * @abstract
 * @extends {AbstractDownloadableService<Invoicing>}
 */
export class InvoicingPmsApiService extends AbstractDownloadableService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/invoicing';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {Invoicing}
     * @protected
     */
    newModel(attributes, ...params) {

        return new Property(attributes);
    }

    /**
     * @param {Property=} property
     * @returns {Promise.<Property>}
     */
    get(property) {

        const url = this.url({propertyId: property.id});

        return this.http
                .get(url, {
                    headers: this.authHeaders
                })
                .then(this.getModeler())
                .catch(this.getErrorHandler());
    }

    /**
     * @param {Property} property
     * @param {Invoicing} invoicing
     * @returns {Promise.<Property>}
     */
    save(property, invoicing) {

        const url = this.url({propertyId: property.id});

        return this.http
                .post(url, invoicing, {
                    headers: this.authHeaders
                })
                .then(this.getModeler())
                .catch(this.getErrorHandler());
    }

    preview(property) {

        const url = `${this.url({propertyId: property.id})}/preview`;

        return new Promise((resolve, reject) => {
            resolve(url);
        });
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/invoicing.service.js